import React from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import ActionButton from "../utils/ActionButton";
import { useRef, useState, useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../styles/Faq.css";
import "../styles/Aerospace.css";
import InformationFaqSection from "./InformationFaqSection";
import TabTitle from "../components/TabTitle";
import DataSources from "../components/DataSources";

function Information() {
  return (
    <div>
      <LandingSection
        data={{
          imageName: "Information.webp",
          title: "Information",
        
        }}
      />
      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>
              Involves working with Technology.Cutting-edge programs and
              research in a vibrant tech hub.
            </h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              Explore the future of tech with the University of Utah's
              innovative Information Systems programs and research
              opportunities.Gain in-demand IT skills and connect with industry
              leaders through the University of Utah's Information Systems
              programs.
            </p>
            
          </div>
        </div>
      </div>
      <TabTitle />

      <InformationFaqSection />
      <DataSources
        sources={[
          "https://ledextract.ces.census.gov/qwi/all",
          "https://jobs.utah.gov/wi/data/library/employment/emptrends.html",
          "https://www.usgs.gov/search?keywords=science%2Btechnology",
          "https://www.bls.gov/iag/tgs/iag51.htm",
          "https://www.edcutah.org/research/research-main",
        ]}
      />
      <Footer />
    </div>
  );
}

export default Information;
